module.exports = __webpack_public_path__ + "static/img/logo.631e7a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/logo.png
// module id = 46la
// module chunks = 18